import React, { useCallback, useMemo } from 'react';
import { useFocusIdx } from '@bay-email/editor';
import { SelectField } from '../../../components/Form';
import { useFontFamily } from '@extensions/hooks/useFontFamily';
import { usePageDefaults } from '@extensions/hooks/usePageDefaults';
import { t } from '@bay-email/core';

export function FontFamily({ name }: { name?: string }) {
	const { focusIdx } = useFocusIdx();
	const { fontList } = useFontFamily();
	const { fontFamily } = usePageDefaults();

	const fieldName = name || `${focusIdx}.attributes.font-family`;

	// Render each option in its own font (stylized preview), matching the toolbar.
	const options = useMemo(
		() => fontList.map(f => ({ value: f.value, label: f.label })),
		[fontList],
	);

	// Keep search working now that the label is a styled node rather than plain text:
	// match the typed text against the font value (which contains the family name).
	const filterOption = useCallback(
		(inputValue: string, option: { props: { value?: string } }) =>
			String(option?.props?.value || '')
				.toLowerCase()
				.includes(inputValue.toLowerCase()),
		[],
	);

	return useMemo(() => {
		return (
			<SelectField
				showSearch
				filterOption={filterOption}
				label={t('Font family')}
				name={fieldName}
				options={options}
				placeholder={fontFamily}
			/>
		);
	}, [focusIdx, options, fieldName, fontFamily, filterOption]);
}
